<template>
  <ApolloQuery
    :query="require('../graphql/GetNewsById.gql')"
    :variables="{ id: parseInt(this.$route.params.id) }"
  >
    <template slot-scope="{ result: { data }, isLoading }">
      <div v-if="isLoading" class="not-found">
        <div class="flex-container center">
          <v-progress-circular color="#1c1c1c" indeterminate />
        </div>
      </div>
      <div v-else-if="!data.GetNewsById.ok" class="not-found">
        Eror 404 : Not Found
      </div>
      <div v-else class="flex-container d-flex flex-column">
        <div
          class="relative flex-container d-flex flex-column ai-center"
          v-bind:class="{ 'bg-dark': !isMobile }"
        >
          <div v-if="!isMobile" class="mg-150" />
          <div
            class="section-wrapper article d-flex flex-column"
            v-bind:class="{
              'color-white mg-150': !isMobile,
              'mg-50': isMobile,
            }"
          >
            <div class="text-1">
              {{ `About > News > ${data.GetNewsById.news.category.name}` }}
            </div>
            <div class="header-3 kor">{{ data.GetNewsById.news.title }}</div>
            <ul class="text-1 mg-50">
              <li>{{ data.GetNewsById.news.timestamp }}</li>
              <li>{{ data.GetNewsById.news.author }}</li>
            </ul>
            <div class="mg-100" />
          </div>
        </div>
        <div class="relative flex-container d-flex flex-column ai-center">
          <div v-if="!isMobile" class="mg-150" />
          <div
            class="section-wrapper article d-flex flex-column"
            v-html="data.GetNewsById.news.body"
          />
          <div class="mg-50" />
        </div>
      </div>
      <div class="flex-container center">
        <div class="section-wrapper article d-flex flex-column">
          <v-btn text color="#131313" width="100px" @click="goBack">
            <v-icon>mdi-chevron-left</v-icon>돌아가기
          </v-btn>
        </div>
      </div>
      <div class="mg-50" />
    </template>
  </ApolloQuery>
</template>

<script>
export default {
  computed: {
    isMobile() {
      return window.innerWidth < 1000;
    },
  },
  methods: {
    goBack() {
      this.$router.push("/about");
    },
  },
};
</script>

<style>
.not-found {
  width: 100vw;
  height: 100vh;
  position: absolute;
  display: -ms-flexbox;
  display: -webkit-flex;
  display: flex;
  z-index: 10000;
  font-size: 50px;
  background: white;
  font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Oxygen,
    Ubuntu, Cantarell, "Open Sans", "Helvetica Neue", sans-serif;
}

p > img {
  width: 70%;
  object-fit: cover;
  margin-left: 15%;
  margin-right: 15%;
}

.article {
  padding: 0 100px;
}

@media only screen and (max-width: 880px) {
  .article {
    padding: 0;
  }
}
</style>
